export const userGQLSchema = `
id
MainInfo {
  FirstName
  LastName
}
Permissions {
  Statistics
  Categories
  Articles
  Users
}
Info {
  CreatedAt
  LastLogin
  Active
}
Credentials {
  Email
}`;
